import { Helmet } from "react-helmet-async";

const SITE = "RetatrutideGuide.org";
const OG_IMAGE = "https://static.prod-images.emergentagent.com/jobs/a2b41fc2-bfd1-45de-9c37-8a2cd443caf0/images/849054f8fbce9ec0c8b8cea3b4d8028ac21416ed151e18f51c10114cd87c5bd0.png";

export default function SEOHead({ title, description, path = "/", type = "website" }) {
  const fullTitle = title ? `${title} | ${SITE}` : `${SITE} | Definitive Triple-Agonist Research Resource`;
  const url = `https://retatrutideguide.org${path}`;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />

      {/* Open Graph */}
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:type" content={type} />
      <meta property="og:image" content={OG_IMAGE} />
      <meta property="og:image:width" content="1024" />
      <meta property="og:image:height" content="1024" />
      <meta property="og:site_name" content={SITE} />

      {/* Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={OG_IMAGE} />
    </Helmet>
  );
}
